<template>
  <div class="ranu-index">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t('menu.ranu'), disabled: true },
        { title: this.$t('ranu.records.title'), disabled: true }
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">

        <Searchable class="mr-2" :querySearch.sync="querySearch"/>

        <div v-if="canWriteRecords">
          <va-popover
            placement="left"
            :message="$t('ranu.records.upload_file')">
            <span class="icon i-cloud-upload align-middle" @click.prevent="importRecords"
                  :disabled="isCreatingRecord"></span>
          </va-popover>
        </div>

        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters"/>

      </div>

    </Breadcrumbs>

    <div class="btn btn__floating btn__round__large" v-if="canWriteRecords" @click="createRecord">
      <va-popover
        placement="left"
        :message="$t('ranu.create')"
      >
        <va-button>
          <i class="fa fa-plus"></i>
        </va-button>
      </va-popover>
    </div>

    <RecordsTable
      ref="recordsTableView"
      :querySearch="querySearch"
      :custom-queries="customQueries"
      :serviceUrl="component.service.url"
      :serviceSlug="serviceSlug"
      :component="component"
      :readEntities="readEntities"
      :showFilters.sync="showFilters"
      @filters-updated="onFiltersUpdated"
    >
    </RecordsTable>

    <CreateOrUpdate v-if="isCreatingRecord"
                    @created="refreshTableAndRedirect"
                    @updated="refreshTable"
                    @destroyed="refreshTable"
                    @modal-closed="onCreateRecordModalClosed"
    >
    </CreateOrUpdate>

    <RecordsImporter
      v-if="isImportingRecords"
      @modal-closed="onImportModalClosed"
      @import-success="onImportSuccess">
    </RecordsImporter>
  </div>

</template>
<script>

import RecordsTable from '@/components/ranu/records/RecordsTable'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import Searchable from '@/components/common/Searchable'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import { TABLE_RANU_RECORDS } from '@/local-storage/LocalStorageKeys'
import Filters from '@/components/common/Filters'
import CreateOrUpdate from '@/components/ranu/records/CreateOrUpdate'
import RecordsImporter from '@/components/ranu/records/RecordsImporter'

const recordsInfoType = 100
const readWriteAccessType = 2

export default {
  components: {
    RecordsImporter,
    CreateOrUpdate,
    Filters,
    Searchable,
    Breadcrumbs,
    RecordsTable
  },
  props: {
    serviceSlug: {
      type: String,
      required: true,
    },
    component: {
      type: Object,
      required: true
    }
  },
  mixins: [
    IndexTablesMixin
  ],
  data: function () {
    return {
      isCreatingRecord: false,
      isImportingRecords: false,
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_RANU_RECORDS,
      customQueries: null
    }
  },
  computed: {
    permissions: function () {
      const ranuService = this.$store.state.services.find(service => service.url === this.$store.state.ranu_server) || null
      if (ranuService) {
        return ranuService.user_permissions
      }
      return []
    },
    canWriteRecords: function () {
      return this.permissions.some(permission => permission.info_type === recordsInfoType && permission.access_type === readWriteAccessType)
    },
    readPermissions: function () {
      return this.permissions.filter(permission => permission.info_type === recordsInfoType)
    },
    readEntities: function () {
      return this.component.service.entities.filter(entity => this.readPermissions.some(permission => permission.entity_id === entity.id || permission.entity_id === null))
    }
  },
  methods: {
    onImportSuccess: function ({ records }) {
      if (records.length) {
        this.refreshTable()
        this.showToast(this.$t('ranu.records.import_result', { number: records.length }), this.$store.state.successToastOptions)
      } else {
        this.showToast(this.$t('ranu.records.import_no_results'), this.$store.state.successToastOptions)
      }
    },
    onImportModalClosed: function () {
      this.isImportingRecords = false
    },
    importRecords: function () {
      this.isImportingRecords = true
    },
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
      if (activeFilters > 0) this.showFilters = true
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    createRecord: function () {
      this.isCreatingRecord = true
    },
    onCreateRecordModalClosed: function () {
      this.isCreatingRecord = false
    },
    refreshTable: function () {
      this.$refs.recordsTableView.refresh()
    },
    refreshTableAndRedirect: function (data) {
      this.$refs.recordsTableView.refresh()
      this.$router.push({ name: `${this.serviceSlug}ranu/id`, params: { id: data.record.id } })
    }
  }
}
</script>

<style lang="scss">

.fa-pencil.custom-pencil {
  cursor: pointer;
  color: #29c4a9;
  font-size: 0.75em;
}

.icons-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 20px;
  margin-top: 10px;
}

.slide-transition-enter-active, .component-fade-leave-active {
  transition: opacity 1s ease;
}

.slide-transition-enter, .component-fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

</style>
